import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);
import app from './modules/app';
import user from './modules/user';
import fault from './modules/fault';
import task from './modules/task';
import index from './modules/index';


const store = new Vuex.Store({
    // state: {
    //     //
    // },
    // mutations: {
    //     //
    // },
    // actions: {
    //
    // },
    modules: {
        app,
        user,
        fault,
        task,
        index
    }
});

export default store;
